import { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { getUserInfo } from '../../apis/user';
import { DirectoryBar } from '../../components/DirectoryBar';
import { Section } from '../../components/Section';
import { CancelDetail } from './CancelDetail';
import { InquireAdd } from './InquireAdd';
import { InquireDetail } from './InquireDetail';
import { MyPageCancels } from './MyPageCancels';
import { MyPageEdit } from './MyPageEdit';
import { MyPageHome } from './MyPageHome';
import { MyPageInquire } from './MyPageInquire';
import { MyPageOrders } from './MyPageOrders';
import { MyPageOrdersCancel } from './MyPageOrdersCancel';
import { MyPageOrdersEditSize } from './MyPageOrdersEditSize';
import { MyPageOrdersExchange } from './MyPageOrdersExchange';
import { MyPageOrdersRefund } from './MyPageOrdersRefund';
import { MyPagePoint } from './MyPagePoint';
import { MyPageRefunds } from './MyPageRefunds';
import { MyPageSidebar } from './MyPageSidebar';
import { OrderDetail } from './OrderDetail';
import { RefundDetail } from './RefundDetail';

export const MyPage = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        getUserInfo().then((r) => null).catch(e => console.log(e));
    }, []);

    return (
        <>
            <DirectoryBar text="마이페이지" className="hidden md:block" />

            {pathname === '/mypage' && (
                <DirectoryBar text="마이페이지" className="md:hidden" />
            )}

            <div className="max-w-screen-2xl mx-auto">
                <Section className="grid grid-cols-6 md:gap-8 md:mt-10">
                    {/* 사이드바 - desktop */}
                    <div className="hidden md:block col-span-2 space-y-7">
                        <MyPageSidebar />
                    </div>

                    {/* 사이드바 - mobile */}
                    {pathname === '/mypage' && (
                        <div className="md:hidden col-span-6 space-y-7 -mx-4">
                            <MyPageSidebar />
                        </div>
                    )}

                    {/* 우측 하단 상세 페이지 */}
                    <div className="col-span-6 md:col-span-4">
                        <Switch>
                            <Route path="/mypage/inquire/add" component={InquireAdd} />
                            <Route path="/mypage/inquire/:id" component={InquireDetail} />
                            <Route path="/mypage/edit" component={MyPageEdit} />
                            <Route path="/mypage/inquire" component={MyPageInquire} />
                            <Route path="/mypage/point" component={MyPagePoint} />
                            <Route
                                path="/mypage/refunds/:orderNumber"
                                component={RefundDetail}
                            />
                            <Route path="/mypage/refunds" component={MyPageRefunds} />
                            <Route
                                path="/mypage/cancels/:orderNumber"
                                component={CancelDetail}
                            />
                            <Route path="/mypage/cancels" component={MyPageCancels} />
                            <Route
                                path="/mypage/orders/:orderNumber/refund"
                                component={MyPageOrdersRefund}
                            />
                            <Route
                                path="/mypage/orders/:orderNumber/exchange"
                                component={MyPageOrdersExchange}
                            />
                            <Route
                                path="/mypage/orders/:orderNumber/edit-size"
                                component={MyPageOrdersEditSize}
                            />
                            <Route
                                path="/mypage/orders/:orderNumber/cancel"
                                component={MyPageOrdersCancel}
                            />
                            <Route
                                path="/mypage/orders/:orderNumber"
                                component={OrderDetail}
                            />
                            <Route path="/mypage/orders" component={MyPageOrders} />
                            <Route path="/mypage" component={MyPageHome} exact />
                            <Route path="/">
                                <Redirect to="/mypage" />
                            </Route>
                        </Switch>
                    </div>
                </Section>
            </div>
        </>
    );
};
